import {
  FiGrid,
  FiShoppingBag,
  FiShoppingCart,
  FiCreditCard,
  FiTag,
  FiBriefcase,
  FiFileText,
  FiClipboard,
  FiTruck,
  FiGift,
  FiDollarSign,
  FiPercent,
  FiImage,
  FiPackage,
  FiUserCheck,
  FiStar,
  FiCheckCircle,
  FiAward,
  FiSettings,
  FiMapPin,
  FiLayout,
  FiBell,
  FiAlertCircle,
  FiBarChart2,
  FiTarget,
  FiUsers,
  FiUpload,
  FiTrash2,
  FiLayers,
  FiExternalLink,
  FiKey,
} from "react-icons/fi";

const iconSize = 18;

const SideNavData = [
  {
    identifier: "Dashboard",
    title: "Dashboard",
    path: "/",
    icon: <FiGrid size={iconSize} />,
  },
  {
    identifier: "Shopkeeper",
    title: "Shopkeepers ",
    path: "/Shopkeepers",
    icon: <FiShoppingBag size={iconSize} />,
    iconClose: <FiShoppingBag size={iconSize} />,
    iconOpen: <FiShoppingBag size={iconSize} />,
  },
  {
    identifier: "Subscription",
    title: "Subscriptions Page",
    path: "/subscription",
    icon: <FiCreditCard size={iconSize} />,
    subNav: [
      {
        subnavigation: true,
        identifier: "Plan",
        title: "Plans",
        path: "/subscription/plans",
        icon: <FiTag size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "SubscriptionPage",
        title: "Subscriptons ",
        path: "/subscription",
        icon: <FiBriefcase size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Request",
        title: "Requests ",
        path: "/subscription/request-Details",
        icon: <FiClipboard size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Modules",
        title: "Modules ",
        path: "/subscription/modules",
        icon: <FiFileText size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Plan Request",
        title: "Plan Requests ",
        path: "/subscription/plan-requests",
        icon: <FiClipboard size={iconSize} />,
      },
    ],
  },
  {
    identifier: "DeliveryOrder",
    title: "Orders",
    path: "/orders",
    icon: <FiShoppingCart size={iconSize} />,
    subNav: [
      {
        subnavigation: true,
        identifier: "Orders",
        title: "Orders",
        path: "/orders",
        icon: <FiShoppingCart size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Delivery For You Vouchers",
        title: "Vouchers",
        path: "/orders/vouchers",
        icon: <FiGift size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Delivery Partners",
        title: "Delivery Partners",
        path: "/orders/delivery-partners",
        icon: <FiTruck size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "d4u Seller Payments",
        title: "Seller Payments",
        path: "/orders/seller-payments",
        icon: <FiDollarSign size={iconSize} />,
      },
    ],
  },
  {
    identifier: "DeliveryOrder",
    title: "Deliver For You [Legacy]",
    path: "/delivery-for-you",
    icon: <FiTruck size={iconSize} />,
    subNav: [
      {
        subnavigation: true,
        identifier: "Delivery For You Orders",
        title: "Orders",
        path: "/delivery-for-you/orders",
        icon: <FiShoppingCart size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Delivery For You Orders Stats",
        title: "Orders Stats",
        path: "/delivery-for-you/stats",
        icon: <FiBarChart2 size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Delivery For You Vouchers",
        title: "Vouchers",
        path: "/delivery-for-you/vouchers",
        icon: <FiGift size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Delivery For You Seller Payments",
        title: "Seller Payments",
        path: "/delivery-for-you/seller-payments",
        icon: <FiDollarSign size={iconSize} />,
      },
    ],
  },
  {
    identifier: "Pricing",
    title: "Pricing",
    path: "/pricing/consumable-items",
    icon: <FiDollarSign size={iconSize} />,
    subNav: [
      {
        subnavigation: true,
        identifier: "Consumable",
        title: "Consumable Items Pricing",
        path: "/pricing/consumable-items",
        icon: <FiTag size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Modules Pricing",
        title: "Modules Pricing",
        path: "/pricing/modules-pricing",
        icon: <FiBriefcase size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Themes Pricing",
        title: "Themes Pricing",
        path: "/pricing/themes-pricing",
        icon: <FiImage size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Delivery Charges",
        title: "Delivery Charges",
        path: "/pricing/delivery-charges",
        icon: <FiTruck size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Delivery Charges",
        title: "Legacy Delivery Charges",
        path: "/pricing/legacy-delivery-charges",
        icon: <FiTruck size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Platform Commision",
        title: "Platform Commision",
        path: "/pricing/platform-commission",
        icon: <FiPercent size={iconSize} />,
      },
    ],
  },
  {
    identifier: "MarketplaceExpenses",
    title: "Marketplace Expenses",
    path: "/marketplace-expenses",
    icon: <FiBarChart2 size={iconSize} />,
  },
  {
    identifier: "AddonsRequests",
    title: "Addons Requests",
    path: "/addons-requests",
    icon: <FiPackage size={iconSize} />,
  },
  {
    identifier: "RegistrationRequests",
    title: "Seller Registration Requests",
    path: "/seller-registration",
    icon: <FiUserCheck size={iconSize} />,
  },
  {
    identifier: "FeaturedListingsBookings",
    title: "Featured Listings Bookings",
    path: "/featured-listings-bookings",
    icon: <FiAward size={iconSize} />,
  },
  {
    identifier: "Themes",
    title: "Themes",
    path: "/theme",
    icon: <FiImage size={iconSize} />,
  },
  {
    identifier: "MarketplaceOptions",
    title: "Marketplace Options",
    path: "/marketplace-options/shop-features",
    icon: <FiSettings size={iconSize} />,
    subNav: [
      {
        subnavigation: true,
        identifier: "Shop Features",
        title: "Shop Features",
        path: "/marketplace-options/shop-features",
        icon: <FiShoppingBag size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "MarketplaceSettings",
        title: "Settings",
        path: "/marketplace-options/settings",
        icon: <FiSettings size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Delivery Cities",
        title: "Delivery Cities",
        path: "/marketplace-options/delivery-cities",
        icon: <FiMapPin size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Banners & Adverts",
        title: "Banners & Adverts",
        path: "/marketplace-options/configs",
        icon: <FiLayout size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "Sales and Deals",
        title: "Sales and Deals",
        path: "/marketplace-options/sales-deals",
        icon: <FiPercent size={iconSize} />,
      },
    ],
  },
  {
    identifier: "Notifications",
    title: "Notification Center",
    path: "/notification-center",
    icon: <FiBell size={iconSize} />,
  },
  {
    identifier: "PointSystem",
    title: "Point System",
    path: "/Pointsystem",
    icon: <FiTarget size={iconSize} />,
  },
  {
    identifier: "User",
    title: "Users",
    path: "/user",
    icon: <FiUsers size={iconSize} />,
  },
  {
    identifier: "Payment",
    title: "Payments",
    path: "/Payment",
    icon: <FiCreditCard size={iconSize} />,
  },
  {
    identifier: "DataImport",
    title: "Data Import Requests",
    path: "/ImportRequests",
    icon: <FiUpload size={iconSize} />,
  },
  {
    identifier: "UserDeletionRequests",
    title: "Users Deletion Requests",
    path: "/users-deletion-requests",
    icon: <FiTrash2 size={iconSize} />,
  },
  {
    identifier: "ForcedRedirections",
    title: "Forced Redirections",
    path: "/forced-redirections",
    icon: <FiExternalLink size={iconSize} />,
  },
  {
    identifier: "AlertMessages",
    title: "Alert Messages",
    path: "/alert-messages",
    icon: <FiAlertCircle size={iconSize} />,
  },
  {
    identifier: "Component",
    title: "Components",
    path: "/data",
    icon: <FiLayers size={iconSize} />,
  },
  {
    identifier: "Bank",
    title: "Banks",
    path: "/bank",
    icon: <FiCreditCard size={iconSize} />,
  },
  {
    identifier: "ListingReviews",
    title: "Listing Reviews",
    path: "/listing-reviews/dummy",
    icon: <FiStar size={iconSize} />,
    subNav: [
      {
        subnavigation: true,
        identifier: "DummyReviews",
        title: "Dummy Reviews",
        path: "/listing-reviews/dummy",
        icon: <FiStar size={iconSize} />,
      },
      {
        subnavigation: true,
        identifier: "ReviewApprovals",
        title: "Approvals",
        path: "/listing-reviews/approvals",
        icon: <FiCheckCircle size={iconSize} />,
      },
    ],
  },
  {
    // Super-admin only: not a permission column, so it never appears for plain admins.
    identifier: "ApiTokens",
    title: "API Tokens (MCP)",
    path: "/api-tokens",
    icon: <FiKey size={iconSize} />,
  },
];

export default SideNavData;
